import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import SINGLE_RULESET_CONTEXT from "src/context/internal/ruleset";
import { useTranslation } from "react-i18next";
import { Subheading } from "src/components/base/heading";
import RulesetRules from "src/components/rulesets_rules";

export const Route = createFileRoute("/_admin/a/rulesets/$rulesetId/_ruleset/rules")({
    component: RouteComponent,
});

/** Shows a single ruleset's rules */
function RouteComponent() {
    const [t] = useTranslation("admin-ruleset");

    const { ruleset, reset: resetRuleset } = React.useContext(SINGLE_RULESET_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            {!ruleset.plugin_uuid && (
                <>
                    <Subheading>{t("heading.add-new-rules")}</Subheading>
                    <RulesetRules onChange={resetRuleset} ruleset_uuid={ruleset.uuid} />
                    <Subheading>{t("heading.existing-rules")}</Subheading>
                </>
            )}

            {ruleset.rules.map((rule) => (
                <RulesetRules
                    key={rule.uuid}
                    onChange={resetRuleset}
                    ruleset_uuid={ruleset.uuid}
                    rule={rule}
                    immutable={Boolean(ruleset.plugin_uuid)}
                />
            ))}
        </div>
    );
}
